import Image from 'next/image'
import dynamic from 'next/dynamic'
import styles from './banner.module.scss'

import { VehicleModelContent } from '../MakeModelLanding'
import { capitaliseFirstLetter } from '@/lib/utilities/search'

const Form = dynamic(() => import('../Form'), {
  ssr: false,
})

export type VehicleRange = {
  id: string
  manufacturerName: string
  name: string
}

export type BannerProps = {
  vehicleModelContent: VehicleModelContent
  range: VehicleRange
}

export const Banner = ({ vehicleModelContent, range }: BannerProps) => {
  const { manufacturerName, name: rangeName } = range

  return (
    <section className={styles['section-banner']}>
      <div className={styles.grid}>
        <div className={styles.form}>
          <h1>{capitaliseFirstLetter(manufacturerName)} {capitaliseFirstLetter(rangeName)} lease deals</h1>
          <Form range={range} />
        </div>
        {vehicleModelContent.heroSectionImage && (
          <div className={styles.image}>
            <Image
              src={vehicleModelContent.heroSectionImage}
              alt={`${manufacturerName} ${rangeName}`}
              layout="fill"
              objectFit="cover"
            />
          </div>
        )}
      </div>
    </section>
  )
}